module.exports = __webpack_public_path__ + "img/Night at the Museum.7662c54a.jpeg";